export const BTN_BURGER_TITLE = {
  closed: 'Open Navigation',
  open: 'Close Navigation',
}
